import axios from './axios';

export const ordersAPI = {
  // Dashboard summary
  getDashboardSummary: async () => {
    const response = await axios.get('/orders/dashboard/summary');
    return response.data;
  },

  // CRUD operations
  getAll: async (params) => {
    const response = await axios.get('/orders', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await axios.get(`/orders/${id}`);
    return response.data;
  },

  getReceipt: async (id) => {
    const response = await axios.get(`/orders/${id}/receipt`);
    return response.data;
  },

  create: async (data) => {
    const response = await axios.post('/orders', data);
    return response.data;
  },

  updateStatus: async (id, status) => {
    const response = await axios.patch(`/orders/${id}/status`, { status });
    return response.data;
  },

  updateItem: async (orderId, itemId, data) => {
    const response = await axios.patch(`/orders/${orderId}/items/${itemId}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await axios.delete(`/orders/${id}`);
    return response.data;
  }
};
